<template>
  <div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <td colspan="5">
              <h3 class="red--text">Produtos:</h3>
            </td>
          </tr>
        </thead>
        <thead>
          <tr>
            <th class="text-left">Cód.</th>
            <th class="text-left">Produto</th>
            <th class="text-left">Pre. Venda</th>
            <th class="text-left">Quant.</th>
            <th class="text-left">Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in getVenda.itens" :key="item.id">
            <td>{{ item.produto_id }}</td>
            <td>{{ item.descricao }}</td>
            <td>{{ $helper.formatReal(parseFloat(item.preco_venda)) }}</td>
            <td>{{ item.quantidade }}</td>

            <td>{{ $helper.formatReal(parseFloat(item.total_venda)) }}</td>
            <td colspan="2">
              <!-- <TooltipButton
                  v-if="$helper.verificaPermissao('visualizar-produto')"
                  @click.native="visualizarProduto(item.produto_id)"
                  classButton="ml-2"
                  subtitle="Visualizar"
                  icon="edit"
                  color="primary"
                /> -->
            </td>
          </tr>
          <tr>
            <td colspan="4"><b>Subtotal:</b></td>
            <td colspan="3">
              {{ $helper.formatReal(parseFloat(getVenda.subtotal)) }}
            </td>
          </tr>
          <tr>
            <td colspan="4"><b>Desconto:</b></td>
            <td colspan="3">
              {{ $helper.formatReal(parseFloat(getVenda.desconto)) }}
            </td>
          </tr>
          <tr>
            <td colspan="4"><b>Acréscimo:</b></td>
            <td colspan="3">
              {{ $helper.formatReal(parseFloat(getVenda.acrescimo)) }}
            </td>
          </tr>
          <tr>
            <td colspan="4"><b>Total:</b></td>
            <td colspan="3">
              {{ $helper.formatReal(parseFloat(getVenda.total)) }}
            </td>
          </tr>
          <tr v-if="getVenda.funcionario">
            <td colspan="7">
              <b>Vendedor:</b> {{ getVenda.funcionario.nome_abreviado }}
            </td>
          </tr>
          <tr>
            <td colspan="7"><b>Status:</b> {{ getVenda.status }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-simple-table dense>
      <template v-slot:default v-if="getVenda.cliente">
        <thead>
          <tr>
            <td colspan="2">
              <h3 class="red--text">Cliente:</h3>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>Nome</b></td>
            <td>{{ getVenda.cliente.nome }}</td>
            <td>
              <TooltipButton
                @click.native="visualizarContato(getVenda.cliente.id)"
                classButton="ml-2"
                subtitle="Visualizar"
                icon="search"
                color="primary"
                v-if="$helper.verificaPermissao('visualizar-contato')"
              />
            </td>
          </tr>
          <tr>
            <td><b>CPF/CNPJ</b></td>
            <td>{{ getVenda.cliente.cpf_cnpj }}</td>
            <td></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <td colspan="2">
              <h3 class="red--text">Formas de Pagamento:</h3>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="20%"><strong>Forma</strong></td>
            <td><strong>Valor Pago</strong></td>
          </tr>
          <tr v-for="f in getVenda.formas_pagamento" :key="f.id">
            <td>{{ f.forma }}</td>
            <td>{{ $helper.formatReal(parseFloat(f.valor_pago)) }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
  },
  computed: {
    ...mapGetters(["getVenda"]),
  },
  methods: {
    ...mapActions(["visualizarContato", "visualizarProduto"]),
  },
};
</script>